// The choices a card offers for a field the DATABASE decides (feedback
// sentiment, supply and sub-change urgency, lock type, RAG category). Ask AI
// reads them from the database's own rules and sends them with the draft
// (`input.options`, item #944 batch 2), so no card keeps its own copy.
// A draft made before that carries none: the card then offers only the value
// the draft already holds, which the database already accepted as a choice.
export function optionsFor(input: unknown, field: string, current: unknown): string[] {
  const o = (input as { options?: Record<string, unknown> } | null)?.options?.[field];
  if (Array.isArray(o) && o.length > 0 && o.every((x) => typeof x === 'string')) return o as string[];
  return typeof current === 'string' && current ? [current] : [];
}
